import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgSparkleLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.75 0C21.0843 0 21.3783 0.221284 21.4707 0.542565L21.8635 1.90718C22.0378 2.513 22.4584 3.01788 23.0227 3.29892L23.5843 3.57865C23.839 3.70548 24 3.96549 24 4.25C24 4.53451 23.839 4.79452 23.5843 4.92135L23.0227 5.20108C22.4584 5.48212 22.0378 5.987 21.8635 6.59282L21.4707 7.95744C21.3783 8.27872 21.0843 8.5 20.75 8.5C20.4157 8.5 20.1217 8.27872 20.0293 7.95744L19.6365 6.59282C19.4622 5.987 19.0416 5.48212 18.4773 5.20108L17.9157 4.92135C17.661 4.79452 17.5 4.53451 17.5 4.25C17.5 3.96549 17.661 3.70548 17.9157 3.57865L18.4773 3.29892C19.0416 3.01788 19.4622 2.513 19.6365 1.90718L20.0293 0.542565C20.1217 0.221284 20.4157 0 20.75 0ZM20.75 3.11033C20.5038 3.55204 20.1705 3.93995 19.7701 4.25C20.1705 4.56005 20.5038 4.94796 20.75 5.38967C20.9962 4.94796 21.3295 4.56005 21.7299 4.25C21.3295 3.93995 20.9962 3.55204 20.75 3.11033ZM13 1C13.4371 1 13.8235 1.28387 13.9542 1.70095L15.6758 7.19434C15.8454 7.73547 16.2367 8.17917 16.7524 8.41503L20.4159 10.0906C20.7718 10.2534 21 10.6087 21 11C21 11.3913 20.7718 11.7466 20.4159 11.9094L16.7524 13.585C16.2367 13.8208 15.8454 14.2645 15.6758 14.8057L13.9542 20.299C13.8235 20.7161 13.4371 21 13 21C12.5629 21 12.1765 20.7161 12.0458 20.299L10.3242 14.8057C10.1546 14.2645 9.76327 13.8208 9.24757 13.585L5.58407 11.9094C5.22823 11.7466 5 11.3913 5 11C5 10.6087 5.22823 10.2534 5.58407 10.0906L9.24757 8.41503C9.76327 8.17917 10.1546 7.73547 10.3242 7.19434L12.0458 1.70095C12.1765 1.28387 12.5629 1 13 1ZM13 5.34394L12.2327 7.79244C11.8935 8.87469 11.1108 9.76209 10.0794 10.2338L8.40425 11L10.0794 11.7662C11.1108 12.2379 11.8935 13.1253 12.2327 14.2076L13 16.6561L13.7673 14.2076C14.1065 13.1253 14.8892 12.2379 15.9206 11.7662L17.5957 11L15.9206 10.2338C14.8892 9.76209 14.1065 8.87469 13.7673 7.79243L13 5.34394ZM5.45424 13.701C5.32353 13.2839 4.93709 13 4.5 13C4.06291 13 3.67647 13.2839 3.54576 13.701L2.88479 15.81C2.71521 16.3512 2.32388 16.7949 1.80818 17.0307L0.58407 17.5906C0.228226 17.7534 0 18.1087 0 18.5C0 18.8913 0.228226 19.2466 0.58407 19.4094L1.80818 19.9693C2.32388 20.2051 2.71521 20.6488 2.88479 21.19L3.54576 23.299C3.67647 23.7161 4.06291 24 4.5 24C4.93709 24 5.32353 23.7161 5.45424 23.299L6.11521 21.19C6.28479 20.6488 6.67612 20.2051 7.19182 19.9693L8.41593 19.4094C8.77177 19.2466 9 18.8913 9 18.5C9 18.1087 8.77177 17.7534 8.41593 17.5906L7.19182 17.0307C6.67612 16.7949 6.28479 16.3512 6.11521 15.81L5.45424 13.701ZM3.25423 18.5C3.77396 18.1399 4.20097 17.6616 4.5 17.1051C4.79903 17.6616 5.22604 18.1399 5.74577 18.5C5.22604 18.8601 4.79903 19.3384 4.5 19.8949C4.20097 19.3384 3.77396 18.8601 3.25423 18.5Z"
      fill={props.color}
    />
  </svg>
);

SvgSparkleLarge.displayName = 'SvgSparkleLarge';
const SparkleLarge = withForgeIconProps(SvgSparkleLarge, {
  name: 'Sparkle',
  usage:
    'Use to call attention to new features or launch brief in-workflow guidance',
  related: 'new, highlight, flashlight',
  isLabelRequired: true,
  isNeutralInteractive: false,
  size: 'large',
});
export default SparkleLarge;
